/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeEmailInvoiceRequest, type EmailInvoiceRequest, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/email
 */
export interface EmailRequestBuilder extends BaseRequestBuilder<EmailRequestBuilder> {
    /**
     * Sends a formatted copy of the invoice — line items, totals, amount paid and balance — to the addresses supplied. At least one address is required and every one must be a valid email address. The message goes out under the organization's name, with replies directed to the organization's own email address, and it can be sent in any status, including a draft. Unlike the rest of the invoice endpoints this one is open to sales reps as well as administrators, and it always uses the caller's own organization — the invoice must belong to it. There is no delivery guarantee beyond acceptance by the mail provider, and nothing is recorded on the invoice, so the same invoice can be emailed repeatedly.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: EmailInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * Sends a formatted copy of the invoice — line items, totals, amount paid and balance — to the addresses supplied. At least one address is required and every one must be a valid email address. The message goes out under the organization's name, with replies directed to the organization's own email address, and it can be sent in any status, including a draft. Unlike the rest of the invoice endpoints this one is open to sales reps as well as administrators, and it always uses the caller's own organization — the invoice must belong to it. There is no delivery guarantee beyond acceptance by the mail provider, and nothing is recorded on the invoice, so the same invoice can be emailed repeatedly.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: EmailInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const EmailRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/email";
/**
 * Metadata for all the requests in the request builder.
 */
export const EmailRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: EmailRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeEmailInvoiceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
